// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2B9xW","topBottomGutter":"Layout_topBottomGutter__5JGnS"};